import { atom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'

export const userNameAtom = atomWithStorage('username', '')
export const mailSendAtom = atom<boolean>(false)
export const hasRecurlyProfileAtom = atomWithStorage<boolean>('hasRecurlyProfile', true)
